import script from "./dirct-inqry-dp.vue?vue&type=script&setup=true&lang=js"
export * from "./dirct-inqry-dp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__